import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import { useT } from "../../shared/i18n";
import type { PlacementNotice } from "./usePlacementQuantity";

/**
 * The shared placement-notice snackbar (item-placement-quantity 01): removal
 * offers Undo, errors are dismissible. Both the item list and search render the
 * same chrome so their undo affordance cannot diverge.
 */
export function PlacementQuantitySnackbar({
  notice,
  onClose,
  onUndo,
}: {
  notice: PlacementNotice | null;
  onClose: () => void;
  onUndo: () => void;
}) {
  const t = useT();
  return (
    <Snackbar
      open={notice !== null}
      autoHideDuration={6000}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert
        severity={notice?.undo ? "info" : "error"}
        onClose={onClose}
        action={
          notice?.undo ? (
            <Button
              color="inherit"
              size="small"
              onClick={onUndo}
              data-testid="quantity-undo"
            >
              {t("undo")}
            </Button>
          ) : undefined
        }
      >
        {notice?.message}
      </Alert>
    </Snackbar>
  );
}
